import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AccountSidbarDashboard from "../component/AccountSidbarDashboard";
import { Col, Row } from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useEmail } from "../component/VerifyEmail";
import { Password } from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";

const MyProFile = () => {
  const { EmailVerify, userData } = useEmail();
  const [cart, setCart] = useState([])

  const validationSchema = Yup.object().shape({
    firstname: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "First name can only contain letters")
      .min(2, "First name must be at least 2 characters")
      .required("First name is required"),
    lastname: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Last name can only contain letters")
      .min(2, "Last name must be at least 2 characters")
      .required("Last name is required"),
    email: Yup.string()
      .email("Invalid email address format")
      .required("Email is required"),
    contactNo: Yup.string()
      .matches(/^[0-9]{10}$/, "Contact number must be exactly 10 digits")
      .required("Contact number is required"),
    new_password: Yup.string().min(6, "Password must be at least 6 characters"),
    conf_password: Yup.string().oneOf([Yup.ref('new_password'), null], 'Passwords must match'),
  });



  const [initialValues, setInitialValues] = useState({
    firstname: "",
    lastname: "",
    email: "",
    contactNo: "",
    cur_password: "",
    new_password: "",
    conf_password: "",
    companyAddress: ""
  });
  useEffect(() => {
    EmailVerify();
  }, []);

  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      setVal();
    }
  }, [userData]);

  const setVal = () => {
    setInitialValues({
      firstname: userData.Name || "",
      lastname: userData.lastname || "",
      email: userData.Email || "",
      contactNo: userData.Mobile || "",
      cur_password: userData.Password || "",
      conf_password: "",
      new_password: "",
      companyAddress: userData.companyAddress || ""
    });

    setCart(userData.cart)

  };



  const handleSubmit = async (values) => {
    if (values.new_password && values.conf_password !== values.new_password) {
      toast.error("New Password and Confirm Password Should Match")
      return
    }
    if (values.new_password && values.new_password.length < 6) {
      toast.error("New Password must be at least 6 characters")
      return
    }
    const data = {
      Name: values.firstname,
      lastname: values.lastname,
      Email: values.email,
      Mobile: values.contactNo,
      Password: values.conf_password !== "" ? values.conf_password : values.cur_password,
      companyAddress: values.companyAddress
    }
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/auth/update/UserMasterDetails/${userData._id}`, data)

      if (res.data.isOk) {
        toast.success("Profile Updated Successfully")
        EmailVerify()
      } else {
        toast.error("Something Went Wrong")
      }
    }
    catch (error) {
      console.log(error)
    }
  };

  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showCnfPassword, setShowCnfPassword] = useState(false)

  return (
    <React.Fragment>


      <div className="tab-content mb-6">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="tab-pane active in" id="account-details">
          <div className="icon-box icon-box-side mb-3">
            <span className="icon-box-icon icon-account mr-2">
              <i className="w-icon-user" />
            </span>
            <div className="icon-box-content">
              <h4
                className="icon-box-title mb-0 ls-normal"
                style={{ fontSize: "2rem" }}
              >
                My Profile
              </h4>
            </div>
          </div>
          <div className="profile-info">
            <h4 className="title title-password ls-25 font-weight-bold">
              Account Information
            </h4>
            <hr />
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="form account-details-form">
                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label htmlFor="firstname">First name *</label>
                        <Field name="firstname">
                          {({ field, form }) => (
                            <input
                              {...field}
                              type="text"
                              className="form-control form-control-md"
                              onChange={(e) => {
                                const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                form.setFieldValue("firstname", value);
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          name="firstname"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label htmlFor="lastname">Last name *</label>
                        <Field name="lastname">
                          {({ field, form }) => (
                            <input
                              {...field}
                              type="text"
                              className="form-control form-control-md"
                              onChange={(e) => {
                                const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                form.setFieldValue("lastname", value);
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          name="lastname"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label htmlFor="email">Email address *</label>
                        <Field
                          disabled
                          type="email"
                          id="email"
                          name="email"
                          className="form-control form-control-md"
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label htmlFor="contactNo">Contact Number *</label>
                        <Field name="contactNo">
                          {({ field, form }) => (
                            <input
                              {...field}
                              type="tel"
                              className="form-control form-control-md"
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                                form.setFieldValue("contactNo", value);
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          name="contactNo"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label htmlFor="email">Address </label>
                        <Field
                          // disabled
                          type="text"
                          id="companyAddress"
                          name="companyAddress"
                          className="form-control form-control-md"
                        />

                      </div>
                    </Col>

                  </Row>


                  <h4 className="title title-password ls-25 font-weight-bold mt-5">
                    Change Password
                  </h4>
                  <hr />

                  <Row>


                    <Col md={6}>
                      <div className="form-group">
                        <label htmlFor="new-password">New Password</label>
                        <div className="position-relative">
                          <Field
                            type={showNewPassword ? "text" : 'password'}
                            id="new-password"
                            name="new_password"
                            className="form-control form-control-md"
                          />
                          <button
                            className="button-none"
                            type="button"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            style={{
                              position: "absolute",
                              right: "15px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              background: "none",
                              border: "none",
                              padding: "0",
                              cursor: "pointer",
                              zIndex: 10
                            }}
                          >
                            {showNewPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                          </button>
                        </div>
                        <ErrorMessage
                          name="new_password"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label htmlFor="conf-password">Confirm New Password</label>
                        <div className="position-relative">
                          <Field
                            type={showCnfPassword ? "text" : 'password'}
                            id="conf-password"
                            name="conf_password"
                            className="form-control form-control-md"
                          />
                          <button
                            className="button-none"
                            type="button"
                            onClick={() => setShowCnfPassword(!showCnfPassword)}
                            style={{
                              position: "absolute",
                              right: "15px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              background: "none",
                              border: "none",
                              padding: "0",
                              cursor: "pointer",
                              zIndex: 10
                            }}
                          >
                            {showCnfPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                          </button>
                        </div>
                        <ErrorMessage
                          name="conf_password"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </Col>
                  </Row>

                  <button
                    type="submit"
                    className="btn btn-dark btn-rounded btn-sm d-block mx-auto mb-4"
                    disabled={isSubmitting}
                  >
                    Save Changes
                  </button>
                </Form>
              )}
            </Formik>

          </div>
        </div>
      </div>

    </React.Fragment>
  );
};

export default MyProFile;
